import React from "react";
import "./Servicos.css";
import { motion } from "framer-motion";
import { 
    Car, 
    Search, 
    BookOpen, 
    Users, 
    Settings, 
    ClipboardCheck, 
    Truck, 
    CheckCircle2 
} from "lucide-react";

const services = [
    { icon: <Car size={32} />, title: "PERSONAL CAR" },
    { icon: <Search size={32} />, title: "AVALIAÇÃO TÉCNICA PRÉ-COMPRA" },
    { icon: <BookOpen size={32} />, title: "ASSESSORIA" },
    { icon: <Users size={32} />, title: "TREINAMENTO EM EQUIPES" },
    { icon: <Settings size={32} />, title: "IMPLANTAÇÃO DE PROCESSOS" },
    { icon: <ClipboardCheck size={32} />, title: "DIAGNÓSTICO AVANÇADO" },
    { icon: <Truck size={32} />, title: "IMPORTAÇÃO DE PEÇAS" },
    { icon: <CheckCircle2 size={32} />, title: "REVISÃO PREVENTIVA E REPARATIVA" },
];


const Servicos = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const cardVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5 }
        }
    };

    return (
        <section className="servicos-wrapper">
            <motion.div 
                className="section-header"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
            >
                <h2 className="section-title">NOSSOS <span className="highlight">SERVIÇOS</span></h2>
                <div className="divider"></div>
            </motion.div>

            <motion.div 
                className="services-grid"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                {services.map((service, index) => (
                    <motion.div 
                        key={index} 
                        className="service-card"
                        variants={cardVariants}
                        whileHover={{ 
                            y: -10, 
                            backgroundColor: "var(--bg-secondary)",
                            borderColor: "var(--accent-primary)"
                        }}
                    >
                        <div className="service-icon">
                            {service.icon}
                        </div>
                        <h3>{service.title}</h3>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
};

export default Servicos;